import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import ls from 'localstorage-slim'

interface RouteVisitantProps extends RouteProps {
  component: React.ComponentType
}

export const RouteVisitant = ({
  component: Component,
  ...rest
}: RouteVisitantProps) => {
  const token = ls.get('@Clinik:token')

  return (
    <Route
      {...rest}
      render={({ location }) =>
        token ? (
          <Redirect
            to={{
              pathname: '/scheduling',
              state: { from: location }
            }}
          />
        ) : (
          <Component />
        )
      }
    />
  )
}
